import {
  ASSIGNMENT_DELETE_FAILURE,
  DAILYPLANNING_ERROR_DISMISS,
  DAILYPLANNING_SUCCESS_DISMISS,
  SELECTED_DATE_UPDATE,
  ASSIGNMENT_CREATE_FAILURE,
  ASSIGNMENT_RESCHEDULE_FAILURE,
  POSTINGS_GET_FAILURE,
  TREATMENT_INSTANCES_GET_FAILURE,
  AUTO_ALLOCATE_FAILURE,
  AUTO_UNALLOCATE_FAILURE,
  TREATMENT_INSTANCES_BY_ASSIGNMEN_GET_FAILURE,
} from '../../../actions/constants/types';
import userMessagesReducerFactory from '../../factories/userMessagesReducerFactory';

const userMessages = userMessagesReducerFactory(
  [
    TREATMENT_INSTANCES_GET_FAILURE,
    POSTINGS_GET_FAILURE,
    ASSIGNMENT_CREATE_FAILURE,
    ASSIGNMENT_DELETE_FAILURE,
    ASSIGNMENT_RESCHEDULE_FAILURE,
    AUTO_ALLOCATE_FAILURE,
    AUTO_UNALLOCATE_FAILURE,
    TREATMENT_INSTANCES_BY_ASSIGNMEN_GET_FAILURE,
  ],
  [],
  [DAILYPLANNING_ERROR_DISMISS],
  [DAILYPLANNING_SUCCESS_DISMISS],
  [SELECTED_DATE_UPDATE],
);

export default userMessages;
